<template>
    <icon-wrapper
            icon="mdi-pencil"
            @click:icon="onFocus"
    >
        <textarea
                ref="field"
                v-model="innerModel"
                class="form-table__textarea"
                :class="clazz"
                :tabindex="tabindex"
                :rows="1"
                v-on="on"
                @blur="onBlur"
                @focus="onFocus"
                @mousedown="onMousedown"
                @click="onClick"
                @keydown.stop="onKeydown"></textarea>
    </icon-wrapper>
</template>

<script>
    import FormTableBaseTextarea from "../FormTableBaseTextarea";
    import IconWrapper from "../../component/part/IconWrapper";
    import {FORM_TABLE_EVENT_DISPATCHER} from "../../constants/form-table-event";
    import {KEY_CODE} from "../../constants/keycodes";
    import styleManager from "../../plugins/common/style/style-manager";

    export default {
        name: "FormTableMpsTextarea",
        components: {IconWrapper},
        extends: FormTableBaseTextarea,
        data() {
            return {
                focused: false,
            };
        },
        watch: {
            innerModel() {
                if (!this.$refs.field) return;
                this.$refs.field.value = this.innerModel;
                styleManager.autoGrow(this.$refs.field);
            },
        },
        mounted() {
            styleManager.autoGrow(this.$refs.field);
            this.registerInput(this.$refs.field);
        },
        activated() {
            styleManager.autoGrow(this.$refs.field);
        },
        methods: {
            /**
             * td 입력에 대한 input 의 이벤트 핸들러 객체입니다.
             */
            createEventHandlerObject(el) {
                return {
                    keydown: (e) => {
                        // td에서 Enter 키 입력시 input 에 포커싱합니다.
                        if (KEY_CODE.ENTER === e.keyCode) {
                            e.preventDefault();
                            this.onFocus();
                        }
                    }
                }
            },

            /**
             * Blur 시 모델 값을 변경해 데이터를 업데이트 합니다.
             */
            onBlur() {
                this.focused = false;
                this.model = this.innerModel;
            },

            onFocus() {
                this.focused = true;
                this.$refs.field.focus();
            },

            /**
             * 마우스 클릭으로 Textarea 에 포커싱하는 것을 방지합니다.
             */
            onMousedown(e) {
                if (!this.focused) {
                    e.preventDefault();
                    // td 를 강제 클릭합니다.
                    FORM_TABLE_EVENT_DISPATCHER.TRIGGER_CLICK(e.target);
                }
            },

            /**
             * Textarea 에 포커싱 되었을 때 마우스 클릭을 허용합니다.
             * @param e
             */
            onClick(e) {
                if (this.focused) e.stopPropagation();
            },

            /**
             * Textarea 에 대한 keydown 이벤트 핸들러입니다.
             */
            onKeydown(e) {
                if (!this.keyManager) {
                    e.preventDefault();
                    return this.$alert("KeyManager should be created!");
                }

                switch (e.keyCode) {
                    case KEY_CODE.ENTER:
                        if (!this.keyManager.isPressedSHIFT) { // SHIFT 키가 눌러져 있지 않으면 엔터키 입력시 시 기본 이벤트를 방어하고 enter 이벤트를 부모 컴포넌트로 전달합니다.
                            e.preventDefault();
                            this.onBlur(); // 저장 후
                            this.$emit('next', e); // 다음 라인으로 이동합니다.
                            break;
                        }
                        break;
                    default:
                        break;
                }
            },
        },
    }
</script>

<style scoped>
    .iconWrapper {

    }

    .form-table-mps__textarea {
        width: 100%;
        height: 100%;
        overflow: hidden;
        display: flex;
        flex-direction: row;
        align-items: center;
    }

    textarea {
        resize: none;
        width: 100%;
        min-height: 100%;
        cursor: default;
        overflow: hidden;
    }

    textarea:focus {
        cursor: text;
    }
</style>